import RestaurantsMenu from "./RestaurantsMenu"
import RestaurantMenuProvider, { useRestaurantMenu } from "./RestaurantMenuContext"

export { RestaurantMenuProvider, useRestaurantMenu }
export default RestaurantsMenu
